import { Navigate, useRoutes } from "react-router-dom";
// layouts
import CompactLayout from "../layouts/compact";
// KYC
import { UserKyc } from "./elements";
import KycForm from "../pages/dashboard/userKyc/KycForm";

// ----------------------------------------------------------------------

// KYC-only routes configuration - directly show KYB form
const routes = [
  {
    element: <CompactLayout />,
    children: [
      { path: "/", element: <KycForm /> },
      { path: "kyc", element: <KycForm /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
];

export default function Router() {
  return useRoutes(routes);
}
